import { useState, useEffect } from 'react';
import { BehaviorSubject } from 'rxjs';

import { HotelViewModel } from '@wegoTypes/hotels/hotelViewModel';

const hotelHoveredSubject = new BehaviorSubject<HotelViewModel | undefined>(undefined);
const hotelMarkerHoveredSubject = new BehaviorSubject<HotelViewModel | undefined>(undefined);

export const setHotelHovered = (value: HotelViewModel | undefined) => {
  hotelHoveredSubject.next(value);
};

export const setHotelMarkerHovered = (value: HotelViewModel | undefined) => {
  hotelMarkerHoveredSubject.next(value);
};

export const useHoverFlag = () => {
  const [hotelHovered, setHotelHoveredState] = useState<HotelViewModel | undefined>(undefined);
  const [hotelMarkerHovered, setHotelMarkerHoveredState] = useState<HotelViewModel | undefined>(
    undefined,
  );

  useEffect(() => {
    const subscription = hotelHoveredSubject.subscribe((value) => {
      setHotelHoveredState(value);
    });
    const markerSubscription = hotelMarkerHoveredSubject.subscribe((value) => {
      setHotelMarkerHoveredState(value);
    });
    return () => {
      subscription.unsubscribe();
      markerSubscription.unsubscribe();
    };
  }, []);

  return {
    hotelHovered,
    hotelMarkerHovered,
  };
};
